module.exports = __webpack_public_path__ + "media/images/application/template/email-44cfdf5e4fd78b58a975fcc29aaec933.svg";